import axios from "axios";

const api = axios.create({
  // 如果与页面同源部署，保持默认即可；如需自定义可用环境变量
  baseURL: "/",
  timeout: 10000,
});

// 自动附加 Authorization 头（如存在 jwtToken）
api.interceptors.request.use((config) => {
  try {
    const token = typeof window !== "undefined" ? localStorage.getItem("jwtToken") : null;
    if (token) {
      config.headers = { ...(config.headers as any), Authorization: `Bearer ${token}` } as any;
    }
  } catch {}
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    return Promise.reject(error);
  }
);

export type TokenData = { user: { name: string }; jwtToken: string };

// 交换 GitHub 回调 code -> TokenData
export async function exchangeGithubCode(code: string) {
  const res = await api.post<TokenData>("/api/github_cb", { code });
  return res.data;
}

export default api;
